import { render, staticRenderFns } from "./AccessCardDetail.vue?vue&type=template&id=0cec64d9&scoped=true&"
import script from "./AccessCardDetail.vue?vue&type=script&lang=js&"
export * from "./AccessCardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec64d9",
  null
  
)

export default component.exports